<template>
  <v-dialog
    v-model="opened"
    max-width="500px"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card class="content-container">
      <v-card-title class="title pb-0">
        <v-layout align-center class="text-xs-left">
          <span>Select Questionnaire to attach</span>
          <v-spacer />
          <v-btn
            fab
            small
            class="error--text text-none my-0"
            flat
            @click="$emit('update:opened', false)"
          >
            <v-icon size="25">clear</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-alert
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left mb-4 mx-2"
        >
          You can only attach documents to unlocked questionnaires.
        </v-alert>
        <v-select
          v-model="selectedQuestionnaireId"
          :items="questionnairesMapped"
          item-text="shownName"
          item-value="id"
          class="default-input"
          solo
          hide-details
          placeholder="Select a questionnaire to attach to"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer class="hidden-xs-only" />
        <v-btn
          class="default-input primary text-none"
          @click="attachToQuestionnaire()"
          :disabled="!selectedQuestionnaireId"
          :loading="loading"
        >
          Save
        </v-btn>
        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';

export default {
  name: 'SelectQuestionnaireDialog',
  props: {
    opened: {
      type: Boolean,
    },
    questionnaires: {
      type: Array,
    },
    selectedItems: {
      type: Array,
    },
    currentCompanyId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      selectedQuestionnaireId: null,
    };
  },
  computed: {
    questionnairesMapped() {
      return this.questionnaires.map(a => {
        return {
          id: a.id,
          name: a.name,
          shownName: `${a.formatted_name} (${a.tax_year}) - ${status}`,
        };
      });
    },
  },
  methods: {
    async attachToQuestionnaire() {
      try {
        this.loading = true;
        const response1 = await API.questionnaire.attachToQuestionnaire({
          extractedDocumentIds: this.selectedItems.map(
            d => d.extracted_document_id,
          ),
          id: this.selectedQuestionnaireId,
          companyId: this.currentCompanyId,
        });
        if (response1.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response1.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully attached.',
          });
          this.$emit('update:opened', false);
          this.$emit('refresh-documents');
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem attaching the document. Please refresh the page and try again.',
        });
        this.$emit('update:opened', false);
      } finally {
        this.selectedQuestionnaireId = null;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="postcss"></style>
